import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageGroupService {
  baseURL = environment.API_BASE_PATH;

  constructor(private commonService: CommonService,
    readonly userInfoService: UserInfoService,private http: HttpClient) { }

  getGroupList() {
    let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/tenant/group', headers);
  }

  createGroup(val) {
    let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.http.post(environment.API_BASE_PATH + '/tenant/group', val, headers)
  }

  deleteGroup(id) {
    let headers = { headers: { 'Accept-Version': 'V1','X-Tenant-ID': this.userInfoService.userDetails.tenantID  } };
    return this.commonService.deleteCall(environment.API_BASE_PATH + `/tenant/group/${id}`, headers);
  }

  editGroup(val, id) {
    let headers = { headers: { 'Accept-Version': 'V2','X-Tenant-ID': this.userInfoService.userDetails.tenantID  } };
    return this.commonService.putCall(environment.API_BASE_PATH + `/tenant/group/${id}`, val, headers);
  }

  getGroupByUserId(userId) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/group/user/${userId}`, headers);
  }
}
